export const blurActiveElement = () => {
    if (document.activeElement) {
        const htmlElement = document.activeElement as HTMLElement;
        if (htmlElement.blur)
            htmlElement.blur();
    }
}
